<template>
  <v-container class="fill-height justify-center" fluid>

     <offline @detected-condition="handleConnectivityChange">
      </offline>

    <v-row align="center" justify="center">
      <v-col class="text-center">
        <v-card width="400" class="mx-auto">
          <v-card-text class="p30px">
            <div class="mb25px ac">
              <img src="@/assets/logo.svg" alt="" />
            </div>
            <v-form ref="form" v-model="valid" lazy-validation  @submit="validate">
              <v-text-field v-model="model.username" :rules="usernameRules" label="Username" required outlined color="black"> </v-text-field>
              <v-text-field v-model="model.password" :rules="passwordRules" :type="showPassword ? 'text' : 'password'" label="Password" outlined color="black" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"></v-text-field>
              <v-btn  @click="validate" color="black" dark x-large tile depressed class="text-capitalize fw300 w100 btn-big">Login <v-icon class="ml-3">mdi-arrow-right</v-icon></v-btn>
              <!-- <div class="mt10px ac">
							<v-btn router-link to="/forgot-password" text tile x-large depressed class="ttn fw300 w100">Forgot Password?</v-btn>
						</div> -->
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :multi-line="true" :bottom="true" :left="true">
      {{ snackbarText }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import api from "@/api";
import offline from "v-offline";

export default {
  name: "LoginPage",
  components: {
    offline
  },
  data() {
    return {
      valid: true,
      usernameRules: [v => !!v || "Username is required"],
      passwordRules: [v => !!v || "Password is required"],
      loading: true,
      objUserLoggedIn: null,
      showPassword: false,
      connectionStatus: false,
      model: {},
      snackbar: false,
      snackbarText: ""
    };
  },
  async created() {
    //if user exists, redirect him to home page
    if(localStorage.getItem("objUserLoggedIn")){
        //this.$router.push({ path: "home" });
        window.location.href = "/home";
    }
    this.refresh();
  },
   mounted(){ 
  },
  methods: {
    handleConnectivityChange(status) {
      this.connectionStatus = status;
      console.log("this.connectionStatus is", this.connectionStatus);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.login();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async login() {
      let objResponse = await api.login(this.model);
      console.log("objResponse is", objResponse);

      if (objResponse.blnOk) {
        this.openSnackBar("Login successful!");
        localStorage.setItem("objUserLoggedIn", JSON.stringify(objResponse.objUser));
        window.location.href = "/home";
        //this.$router.push({ path: "home" });
      } else {
        this.openSnackBar(objResponse.msg);
      }
    },
    async refresh() {}, 
    openSnackBar(str) {
      this.snackbarText = str;
      this.snackbar = true;
    }
  }
};
</script>
